import StaffMessaging from "@/components/messaging/StaffMessaging";

export default function DoctorMessaging() {
  return <StaffMessaging defaultRecipientType="clinician" />;
}
